import React from 'react';
import Card from '../../ui/Card';
import { SparklesIcon, TrendingUpIcon, TargetIcon } from 'lucide-react';
const InsightsCards: React.FC = () => {
  const insights = [{
    icon: <TrendingUpIcon size={24} data-id="element-2869" />,
    title: 'Revenue Momentum Strong',
    description: 'Q3 revenue up 12.4% YoY, driven by West region (15.2% growth) and Electrical products (14.8% growth). EV component sales exceeded forecast by 18%.',
    impact: 'Positive',
    color: 'from-green-500 to-emerald-600'
  }, {
    icon: <SparklesIcon size={24} data-id="element-2870" />,
    title: 'Margin Expansion Opportunity',
    description: 'Chennai plant achieved 94% efficiency vs 92% company average. Scaling best practices could improve overall EBITDA by 0.4-0.6 percentage points.',
    impact: 'High Potential',
    color: 'from-blue-500 to-indigo-600'
  }, {
    icon: <TargetIcon size={24} data-id="element-2871" />,
    title: 'Working Capital Optimization',
    description: 'Receivable days reduced from 63 to 58 days. Further improvement to target 52 days could unlock ₹125 Cr in cash flow over next quarter.',
    impact: 'Action Required',
    color: 'from-purple-500 to-pink-600'
  }];
  return <div className="mb-8" data-id="element-2872">
      <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-2873">
        Auto-Generated Insights
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-2874">
        {insights.map((insight, index) => <Card key={index} className={`p-6 bg-gradient-to-br ${insight.color} text-white shadow-lg`} data-id="element-2875">
            <div className="mb-3" data-id="element-2876">{insight.icon}</div>
            <h4 className="text-lg font-bold mb-2" data-id="element-2877">{insight.title}</h4>
            <p className="text-sm mb-4 text-white/90" data-id="element-2878">{insight.description}</p>
            <div className="flex items-center justify-between" data-id="element-2879">
              <span className="text-xs font-semibold px-3 py-1 bg-white/20 rounded-full" data-id="element-2880">
                {insight.impact}
              </span>
              <button className="text-xs font-semibold underline hover:no-underline" data-id="element-2881">
                Learn More →
              </button>
            </div>
          </Card>)}
      </div>
    </div>;
};
export default InsightsCards;